export default "__VITE_ASSET__ce1728cf__"